import React from "react";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

export const microphoneCalibrationColumnStyle = {
  width: 64,
  minWidth: 64,
  maxWidth: 64,
  paddingLeft: 8,
  paddingRight: 8,
  textAlign: "center",
};

export default function MicrophoneCalibrationStatus({ available }) {
  const label = available
    ? "Kalibracja mikrofonu dostępna"
    : "Brak kalibracji mikrofonu";
  const StatusIcon = available ? CheckCircleIcon : CancelIcon;

  return (
    <StatusIcon
      titleAccess={label}
      aria-label={label}
      style={{ color: available ? "#2e7d32" : "#c62828" }}
    />
  );
}
